import { Component, inject, OnInit, ChangeDetectionStrategy, computed } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PublicProfileStore, PublicUser } from 'src/app/stores/public-profile.store';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { environment } from 'src/environments/environment';
import { NICKY_URLS } from 'src/app/utils/urls.constants';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';
import { ProfileHeaderComponent } from '@app/pages/public/public-profile/components/profile-header/profile-header.component';
import { PaymentMethodsComponent } from '@app/pages/public/public-profile/components/payment-methods/payment-methods.component';
import { LoadingSkeletonComponent } from '@app/pages/public/public-profile/components/loading-skeleton/loading-skeleton.component';
import { BackButtonComponent } from '@app/pages/public/public-profile/components/back-button/back-button.component';

@Component({
  selector: 'app-public-profile',
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NickyButtonComponent,
    ProfileHeaderComponent,
    PaymentMethodsComponent,
    LoadingSkeletonComponent,
    BackButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './public-profile.component.html',
})
export class PublicProfileComponent implements OnInit {
  protected dialogRef = inject(DialogRef, { optional: true });
  // If has data it's a resumed public profile
  protected data: PublicUser = inject(DIALOG_DATA, { optional: true });
  protected translate = inject(TranslateService);
  protected toastrService = inject(ToastrService);
  protected publicProfileStore = inject(PublicProfileStore);
  protected route = inject(ActivatedRoute);
  protected router = inject(Router);

  readonly termsOfUseUrl = NICKY_URLS.TERMS_OF_USE;
  readonly privacyPolicyUrl = NICKY_URLS.PRIVACY_POLICY;
  readonly url = environment.websiteUrl;

  protected isInDialog = computed(() => !!this.dialogRef);
  protected minHeightClass = computed(() => {
    if (this.isInDialog()) return '';
    return 'min-h-[calc(100vh-81px)]';
  });

  ngOnInit(): void {
    if (this.data) {
      const resumedProfile = true;
      this.publicProfileStore.setProfileInfo(this.data, resumedProfile);
    }
  }

  protected copyProfileUrl(): void {
    const profileUrl = `${window.location.origin}/s/${this.publicProfileStore.profileInfo().shortId}`;
    navigator.clipboard.writeText(profileUrl);
    this.toastrService.success(
      this.translate.instant('public-profile.theLinkToYourNickyPublicProfileHasBeenCopied'),
      '',
      { timeOut: 3000 },
    );
  }

  protected handleRequiredPaymentRequest(): void {
    if (!this.publicProfileStore.profileInfo().shortId) {
      this.toastrService.error('thisUserIsNotCurrentlyAcceptingPayments');
      return;
    }
    this.router.navigate(['/payment-report', this.publicProfileStore.profileInfo().shortId]);
  }

  protected editMyProfile(): void {
    this.router.navigateByUrl('settings/connections');
  }

  protected handleImageError(event: any): void {
    event.target.onerror = null;
  }
}
